module.exports = __webpack_public_path__ + "img/icon-export-white.2ca3a174.svg";